import { call, put, select } from 'redux-saga/effects';
import { addTeamMemberSaga } from '../../analyticTeamMember/addTeamMember/addTeamMember';
import { fetchAnalyticTeamAction } from '../fetchTeam/action';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../../state/userCredential/userCredentialSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* createTeamSaga(action) {
    const { teamName, teamDescription, memberUids } = action.payload || {};
    const { uid: currentUid } = yield select(selectUserCredentials);
    try {

        const { data } = yield call([backendClient, backendClient.post], 'teams', {
            teamName, teamDescription,
        });

        // Filter out the creator's uid
        const filteredUids = Array.isArray(memberUids)
            ? memberUids.filter(uid => uid !== currentUid)
            : [];

        if (filteredUids.length > 0) {
            yield call(addTeamMemberSaga, {
                payload: { teamId: data.teamId, uids: filteredUids },
                meta: { skipFetch: true, silent: true }
            });
        }
        yield put(fetchAnalyticTeamAction());

        yield put(showSnackbar({
            message: `Team "${data.teamName}" created successfully.`,
            severity: 'success',
        }));
    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to create analytic team', status, err?.message);
        yield put(showSnackbar({
            message: `Failed to create team.`,
            severity: 'error',
        }));
    }
}